import { handleNumberField } from "../../prefill/helpers";
import { FieldRegistryConfig } from "../../types";
import { NumberSliderFieldControl } from "./NumberSliderFieldControl/NumberSliderFieldControl";
import { NumberSliderFieldValue } from "@smartsuite/types";

export const numberSlideFieldConfig: FieldRegistryConfig<NumberSliderFieldValue> = {
  icon: "number-slider",
  control: (props) => <NumberSliderFieldControl {...props} />,
  prefill: handleNumberField,
};
